module.exports = {
      id: "Loader-usage",
      viewBox: "0 0 200 200",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/landing/sprite.svg#Loader-usage",
      toString: function () {
        return this.url;
      }
    }